'use strict';

module.exports = {
    chipsList: 'chipsList',
    startAndEndDates: 'startAndEndDates',
};
